import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import React, { forwardRef } from "react";
import { tesaChipOrange } from "../../styles/colors";

const CustomWaringIcon = forwardRef<SVGSVGElement, React.ComponentProps<typeof ReportProblemOutlinedIcon>>(
  (props, ref) => <ReportProblemOutlinedIcon style={{ color: tesaChipOrange }} ref={ref} {...props} />,
);

export default CustomWaringIcon;
